/**
 *
 */
export enum LayerIndex {
  StageColor = -2000,
  Background = -1000,
  Main = 0,
  Ui = 1000
}
